import facilityDeficiencies from "./facility_deficiencies.png";
import hygienicDeficiencies from "./hygienic_deficiencies.png";
import organizationalDeficiencies from "./organizational_deficiencies.png";
import otherDeficiencies from "./other_deficiencies.png";

type DeficiencyIconProps = {
  type?: "facility" | "hygienic" | "organizational" | "other";
  count?: number;
};

const DEFICIENCY_IMAGES: Record<string, string> = {
  facility: facilityDeficiencies,
  hygienic: hygienicDeficiencies,
  organizational: organizationalDeficiencies,
  other: otherDeficiencies,
};

export const DeficiencyIcon = ({
  type = "facility",
  count,
}: DeficiencyIconProps) => (
  <div
    style={{
      position: "relative",
      display: "inline-block",
    }}
  >
    <img
      src={DEFICIENCY_IMAGES[type]}
      alt="Deficiency icon"
      style={{ height: "100%", display: "block" }}
    />

    {count !== undefined && (
      <div
        style={{
          position: "absolute",
          left: 16,
          top: 24,
          width: 46,
          height: 40,
          display: "flex",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 24,
          color: "#3d5170",
        }}
      >
        {count}
      </div>
    )}
  </div>
);